/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { FilterChipBarV2 } from '../../../../components/v2';
import {
  EMPTY_USO_MUTUO_QUICK_FILTER,
  USO_MUTUO_STATUS_CODES,
  USO_MUTUO_TIPO_CHIPS,
} from '../utils/usoMutuoFilters';

const TIPO_CHIPS = [
  { id: USO_MUTUO_TIPO_CHIPS.POSTE, label: 'Poste' },
  { id: USO_MUTUO_TIPO_CHIPS.ANALISE_RISCO, label: 'Análise de Risco' },
  { id: USO_MUTUO_TIPO_CHIPS.EVIDENCIA_CAMPO, label: 'Evidência' },
  { id: USO_MUTUO_TIPO_CHIPS.ENTREGA_SUCATA, label: 'Entrega Sucata' },
  { id: USO_MUTUO_TIPO_CHIPS.PESAGEM_SUCATA, label: 'Pesagem Sucata' },
];

const STATUS_CHIPS = [
  { id: USO_MUTUO_STATUS_CODES.AGUARDANDO, label: 'Aguardando' },
  { id: USO_MUTUO_STATUS_CODES.EM_ANDAMENTO, label: 'Em andamento' },
  { id: USO_MUTUO_STATUS_CODES.FINALIZADO, label: 'Finalizado' },
];

const SITUACAO_CHIPS = [
  { id: 'Com irregularidade', label: 'Com irregularidade' },
  { id: 'Sem irregularidade', label: 'Sem irregularidade' },
  { id: 'Não compartilhável', label: 'Não compartilhável' },
  { id: 'Não localizado', label: 'Não localizado' },
  { id: 'Vazio', label: 'Em branco' },
];

const toggleChip = (value, field, chipId) => ({
  ...value,
  [field]: value[field] === chipId ? null : chipId,
});

const UsoMutuoQuickFilters = ({
  value,
  onChange,
  filterActive,
  totalCount,
  filteredCount,
}) => {
  const [searchInput, setSearchInput] = useState(value.search || '');

  useEffect(() => {
    setSearchInput(value.search || '');
  }, [value.search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== value.search) {
        onChange({ ...value, search: searchInput });
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [searchInput, onChange, value]);

  const handleClear = () => {
    setSearchInput('');
    onChange(EMPTY_USO_MUTUO_QUICK_FILTER);
  };

  const chipGroups = useMemo(() => [
    {
      label: 'Tipo',
      chips: TIPO_CHIPS.map((chip) => ({
        id: chip.id,
        label: chip.label,
        selected: value.tipoChip === chip.id,
        onClick: () => onChange(toggleChip(value, 'tipoChip', chip.id)),
      })),
    },
    {
      label: 'Status da digitação',
      chips: STATUS_CHIPS.map((chip) => ({
        id: chip.id,
        label: chip.label,
        selected: value.statusChip === chip.id,
        onClick: () => onChange(toggleChip(value, 'statusChip', chip.id)),
      })),
    },
    {
      label: 'Situação do poste',
      chips: SITUACAO_CHIPS.map((chip) => ({
        id: chip.id,
        label: chip.label,
        selected: value.situacaoChip === chip.id,
        onClick: () => onChange(toggleChip(value, 'situacaoChip', chip.id)),
      })),
    },
  ], [value, onChange]);

  return (
    <FilterChipBarV2
      searchLabel="Poste / endereço"
      searchValue={searchInput}
      onSearchChange={setSearchInput}
      searchPlaceholder="Número do poste ou endereço"
      chipGroups={chipGroups}
      chipGroupsLayout="row"
      filterActive={filterActive}
      filteredCount={filteredCount}
      totalCount={totalCount}
      countLabel="postes"
      onClear={handleClear}
    />
  );
};

UsoMutuoQuickFilters.propTypes = {
  value: PropTypes.shape({
    search: PropTypes.string,
    tipoChip: PropTypes.string,
    statusChip: PropTypes.string,
    situacaoChip: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  filterActive: PropTypes.bool,
  totalCount: PropTypes.number.isRequired,
  filteredCount: PropTypes.number.isRequired,
};

UsoMutuoQuickFilters.defaultProps = {
  filterActive: false,
};

export default UsoMutuoQuickFilters;
